// src/components/common/PageHeader.jsx
import React from 'react';

const PageHeader = ({ title, actions }) => {
  return (
    <div className="mb-6 sm:mb-8">
      <div className="sm:flex sm:items-center sm:justify-between">
        <div>
          <h1 className="break-words text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">{title}</h1>
        </div>
        {actions && actions.length > 0 && (
          <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
            <div className="flex flex-wrap gap-2 sm:gap-3">
              {actions.map((action, index) => (
                <button
                  key={index}
                  onClick={action.onClick}
                  type="button"
                  className={`inline-flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                    action.variant === 'primary'
                      ? 'bg-primary-600 text-white hover:bg-primary-500 focus-visible:outline-primary-600'
                      : 'bg-white text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50'
                  }`}
                >
                  {action.icon && <span className="text-base">{action.icon}</span>}
                  {action.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
